"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _ = require("../../..");
var _styled = require("../../../base/styled");
var _constant = require("../../../../constant");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _instagram = _interopRequireDefault(require("../../../../assets/svg/instagram.svg"));
var _facebook = _interopRequireDefault(require("../../../../assets/svg/facebook.svg"));
var _linkedin = _interopRequireDefault(require("../../../../assets/svg/linkedin.svg"));
var _tiktok = _interopRequireDefault(require("../../../../assets/svg/tiktok.svg"));
var _styled2 = require("../styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var People = function People(_ref) {
  var company = _ref.company,
    open = _ref.open,
    onCollapse = _ref.onCollapse,
    isValid = _ref.isValid,
    showValidateIcon = _ref.showValidateIcon;
  return /*#__PURE__*/_react.default.createElement(_.Collapsible, {
    id: _constant.companySection.PEOPLE,
    onCollapse: onCollapse,
    title: "People",
    open: open.people,
    isValid: isValid,
    showValidateIcon: showValidateIcon
  }, (company.welcome || company.welcomeCaption || company.welcomeImageUrl) && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Welcome to ", company.name, "!"), company.welcomeImageUrl && /*#__PURE__*/_react.default.createElement(_.FilePreview, {
    url: company.welcomeImageUrl,
    fileName: company.welcomeImageFileName,
    imageHeight: "100%",
    imageWidth: "100%"
  }), /*#__PURE__*/_react.default.createElement(_styled.Text, {
    $bsStyle: {
      fontStyle: 'italic'
    }
  }, company.welcomeCaption), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.welcome)), !(0, _isEmpty.default)(company.videos) && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Meet Our Team"), company.videos.map(function (video) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: video.id
    }, video.url && /*#__PURE__*/_react.default.createElement(_.FilePreview, {
      url: video.url,
      fileName: video.fileName,
      imageHeight: "100%",
      imageWidth: "100%"
    }), /*#__PURE__*/_react.default.createElement(_styled.Text, {
      $bsStyle: {
        fontStyle: 'italic'
      }
    }, video.caption), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, video.title));
  })), company.influencers[0] && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Our Favorite Influencers"), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, company.influencers.map(function (influencer, index) {
    return /*#__PURE__*/_react.default.createElement(_styled.Column, {
      key: index,
      $bsStyle: {
        marginRight: '16px'
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      style: {
        display: 'table-cell',
        textDecoration: 'none',
        textAlign: 'center'
      },
      href: influencer.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, influencer.socialNetwork === 1 && /*#__PURE__*/_react.default.createElement("img", {
      src: _instagram.default,
      alt: "instagram",
      style: {
        width: '32px'
      }
    }), influencer.socialNetwork === 2 && /*#__PURE__*/_react.default.createElement("img", {
      src: _linkedin.default,
      alt: "linkedin",
      style: {
        width: '32px'
      }
    }), influencer.socialNetwork === 3 && /*#__PURE__*/_react.default.createElement("img", {
      src: _facebook.default,
      alt: "facebook",
      style: {
        width: '32px'
      }
    }), influencer.socialNetwork === 4 && /*#__PURE__*/_react.default.createElement("img", {
      src: _tiktok.default,
      alt: "twitter",
      style: {
        width: '32px'
      }
    })), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
      $bsStyle: {
        marginTop: '0px',
        marginBottom: '0px'
      },
      href: influencer.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, influencer.name));
  }))));
};
People.propTypes = {
  onCollapse: _propTypes.default.func.isRequired,
  company: _utils.companyProps.isRequired,
  open: _utils.opportunitySectionsProps.isRequired,
  isValid: _propTypes.default.bool.isRequired,
  showValidateIcon: _propTypes.default.bool
};
People.defaultProps = {
  showValidateIcon: false
};
var _default = People;
exports.default = _default;